import React, { useState, useEffect } from 'react';

// https://mobcup.net/ringtone/bloop-z35gr6uf
const song = require('./TaskComplete.mp3');

function Timer() {
  const [timer, setTimer] = useState(null);
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('');
  const [seconds, setSeconds] = useState('');
//   const [amPm, setAmPm] = useState('AM');
  const [remainingTime, setRemainingTime] = useState(null);

  useEffect(() => {
    if (timer === null) {
      return;
    }

    const interval = setInterval(() => {
      setRemainingTime((prevRemainingTime) => {
        if (prevRemainingTime <= 0) {
          clearInterval(interval);
            playSong();
          setTimer(null);
          return 0;
        }
        return prevRemainingTime - 1;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
      setTimer(null)
    };
  }, [timer]);

  const playSong = () => {
    const audioElement = new Audio(song);
    audioElement.play();
  };

  const startTimer = () => {
    const hoursNum = parseInt(hours, 10) || 0;
    const minutesNum = parseInt(minutes, 10) || 0;
    const secondsNum = parseInt(seconds, 10) || 0;

    let totalSeconds = hoursNum * 3600 + minutesNum * 60 + secondsNum;
    // if (amPm === 'PM') {
    //   totalSeconds += 12 * 3600; // Convert to 24-hour format
    // }

    if (totalSeconds<=0) {
      alert('Please enter a Time before starting the timer.');
      return
    }
    setRemainingTime(totalSeconds);
    setTimer(true);
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600) % 24;
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div>
      {!timer && (
        <div>
            <table>
              <thead>
                <tr>
                    <th>
                      <label className='btnBorder hunderedPxWidth'>Hours</label>
                    </th>
                    <th>
                      <label className='btnBorder hunderedPxWidth'>Minutes</label>
                    </th>
                    <th>
                      <label className='btnBorder hunderedPxWidth'>Seconds</label>
                    </th>
                    {/* <th>
                      <label className='btnBorder hunderedPxWidth'>AM | PM</label>
                    </th> */}
                </tr> 
              </thead>
              <tbody>
                <tr>
                    <td>
                        <input
                            type="number"
                            placeholder="HH"
                            value={hours}
                            className='btnBorder hunderedPxWidth'
                            onChange={(e) => setHours(e.target.value)}
                        />
                    </td>
                    <td>
                        <input
                            type="number"
                            placeholder="MM"
                            value={minutes}
                            className='btnBorder hunderedPxWidth'
                            onChange={(e) => setMinutes(e.target.value)}
                        />
                    </td>
                    <td>
                        <input
                            type="number"
                            placeholder="SS"
                            value={seconds}
                            className='btnBorder hunderedPxWidth'
                            onChange={(e) => setSeconds(e.target.value)}
                        />
                    </td>
                    {/* <td>
                        <select value={amPm} onChange={(e) => setAmPm(e.target.value)} className='btnBorder hunderedPxWidth'>
                            <option value="AM">AM</option>
                            <option value="PM">PM</option>
                        </select>
                    </td> */}
                </tr>
              </tbody>
            </table>
          
          <button onClick={startTimer} className='btnBorder'>Start</button>
        </div>
      )}
      {timer && (
        <div>
          <h2 className='btnBorder'>Time Remaining: {formatTime(remainingTime)}</h2>
          <button onClick={() => setTimer(null)} className='btnBorder'>Reset</button>
        </div>
      )}
    </div>
  );
}

export default Timer;
